import React from 'react';

export const ArrowRightIcon = (props: React.SVGAttributes<SVGElement>) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z" fill="currentColor" />
  </svg>
);

/* eslint max-len:0 */
